import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const OilFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.8446 8.73579L13.8942 12.0201L13.1515 10.4288H10.8899V8.76215H12.1849V7.43213H8.50427V8.76215H9.78119V10.4288H7.47833V8.91401H2.54761V12.3892H6.112V16.7258H15.5575L21.4769 9.52619L20.8446 8.73579ZM6.14831 10.4288V11.0592H3.87762V10.244H6.14831V10.4288ZM14.872 15.3959H7.44196V11.7589H12.3046L13.254 13.7936L17.4137 11.828L14.872 15.3959ZM21.502 12.1813C19.9125 13.9594 20.7328 15.4189 21.502 15.4189C22.2511 15.4189 23.1573 14.1033 21.502 12.1813Z" />
      <path d="M6.14831 10.4288V11.0592H3.87762V10.244H6.14831V10.4288Z" />
      <path d="M14.872 15.3959H7.44196V11.7589H12.3046L13.254 13.7936L17.4137 11.828L14.872 15.3959Z" />
    </SvgIcon>
  );
});
